<script>
    import { mapActions, mapState } from "vuex";
    import Swiper from "@/plugins/swiper-bundle";
    import ApplicationFeaturesCard from "@picooc/components/ApplicationFeaturesCard";
    import SliderControls from "@picooc/components/SliderControls";

    export default {
        name: "ApplicationFeatures",
        components: { SliderControls, ApplicationFeaturesCard },
        data() {
            return {
                sliderActiveIndex: 1,
                slider: null,
            };
        },
        computed: {
            ...mapState("Picooc", ["applicationFeatures"]),
        },
        serverPrefetch() {
            return this.getTextCards("app-features");
        },
        mounted() {
            if (this.applicationFeatures.length === 0) {
                this.getTextCards("app-features").then(() => {
                    this.initSlider();
                });
            } else {
                this.initSlider();
            }
        },
        methods: {
            ...mapActions("Picooc", ["getTextCards"]),
            initSlider() {
                this.$nextTick(() => {
                    this.slider = new Swiper(".js-application-features-slider", {
                        spaceBetween: 20,
                        direction: "horizontal",
                        grabCursor: true,
                        navigation: {
                            nextEl: `.js-application-features-next`,
                            prevEl: `.js-application-features-prev`,
                        },
                    });

                    this.slider.on("slideChange", (slider) => {
                        this.sliderActiveIndex = slider.activeIndex + 1;
                    });
                });
            },
        },
    };
</script>

<template>
    <section class="application-features application__section">
        <h2 class="application-features__title page-title">Возможности приложения</h2>

        <div v-if="applicationFeatures.length === 0" class="application-features__loader">
            <preloader :show="true" lg-size></preloader>
        </div>

        <div
            v-if="applicationFeatures.length > 0"
            class="application-features__list mobile-hidden"
        >
            <div
                class="application-features__item"
                v-for="feature in applicationFeatures"
                :key="feature.id"
            >
                <application-features-card :feature="feature"></application-features-card>
            </div>
        </div>

        <div
            v-if="applicationFeatures.length > 0"
            class="application-features__slider desktop-hidden"
        >
            <div class="swiper-container js-application-features-slider">
                <div class="swiper-wrapper">
                    <div
                        class="swiper-slide application-features__slide"
                        v-for="feature in applicationFeatures"
                        :key="feature.id"
                    >
                        <application-features-card
                            :feature="feature"
                        ></application-features-card>
                    </div>
                </div>
            </div>
            <div class="application-features__counter desktop-hidden">
                <slider-controls
                    :current="sliderActiveIndex"
                    :max="applicationFeatures.length"
                    name="js-application-features"
                ></slider-controls>
            </div>
        </div>
    </section>
</template>

<style lang="scss">
    .application-features {
        position: relative;
        background-color: #f4fbff;
        background-image: url("/static/picooc/application/features-fill--m.svg");
        background-size: cover;
        @include bp($bp-desktop-sm) {
            background-image: url("/static/picooc/application/features-fill--d.svg");
            overflow: hidden;
        }
    }

    .application-features__title {
        margin-bottom: 15px;
        @include bp($bp-desktop-sm) {
            margin-bottom: 12px;
        }
    }

    .application-features__loader {
        position: relative;
        min-height: 150px;
    }

    .application-features__list {
        @include bp($bp-desktop-sm) {
            display: flex;
            flex-wrap: wrap;
            margin: 0 -25px -45px;
        }
    }

    .application-features__item {
        @include bp($bp-desktop-sm) {
            flex-basis: 50%;
            max-width: 50%;
            padding: 0 25px 45px;
        }
    }

    .application-features__slider {
        margin: 0 -16px;
    }

    .application-features__slide {
        img {
            margin: 0 auto;
        }
    }

    .application-features__counter {
        margin-bottom: 16px;
        padding: 0 35px;
    }
</style>
